module.exports = new __parcel__URL__("gallery_5.7096a494.jpg").toString();